import API from "./api";

export const login = async (username, password) => {
  const res = await API.post("/api/login", {
    username,
    password
  });

  localStorage.setItem("token", res.data.access_token);
  localStorage.setItem("role", res.data.role);
  return {
    token: res.data.access_token,
    role: res.data.role
  };
};

export const getCurrentUser = async () => {
  const res = await API.get("/api/me");
  localStorage.setItem("role", res.data.role);
  return res.data;
};
